import { useIntl } from "react-intl";
import { NavLink } from "react-router-dom";
import { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//Components
import { Grid, Typography, Container, Paper, Divider } from "@mui/material";
import { Button } from "@gpstrackit/react-controls";
import DataViewInfiniteScroll from 'Components/DataViewInfiniteScroll';

//Views
import AdvancedFilters from 'Modules/keysFobs/views/main/.components/AdvancedFilters';
import CreateEditKeyFob from 'Modules/keysFobs/.components/createEditKeyFob';
import DeleteKeyFob from 'Modules/keysFobs/.components/deleteKeyFob';
import BulkAddDriverIDTags from 'Modules/keysFobs/.components/bulkAddDriverIdTags'
import MoveToAnotherAccount from 'Modules/keysFobs/.components/moveToAnotherAccount'
import UnassignDrivers from 'Modules/keysFobs/.components/unassignDrivers'

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    keyfobsCreateEditOpenModal,
    keyfobsDeleteOpenModal,
    bulkAddDriverIdTagsOpenModal,
    moveToAnotherAccountOpenModal,
    unassignDriversOpenModal,
} from 'Redux/actions';

//Permission
import { HasPermission } from "Core/security"

const KeyFobsMain = (props) => {
    const { messages } = useIntl();
    const tableRef = useRef();
    const dispatch = useDispatch();

    const openModalCreateEdit = useSelector(state => state.createEditKeyFobRedux.openModal);
    const openModalDelete = useSelector(state => state.deleteKeyFobRedux.openModal);
    const openModalBulkAddDriverIdTags = useSelector(state => state.bulkAddDriverIdTagsRedux.openModal);
    const openModalMoveToAnotherAccount = useSelector(state => state.moveToAnotherAccountRedux.openModal);
    const openModalUnassignDrivers = useSelector(state => state.unassignDriversRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);

    const [openPanel, setOpenPanel] = useState(false);
    const [openPanelDetails, setOpenPanelDetails] = useState(false);
    const [account, setAccount] = useState(null);
    const [keyFobModel, setKeyFobModel] = useState(null);

    const [total, setTotal] = useState(0);
    const [columns, setColumns] = useState([
        {
            key: "hex",
            field: "hex",
            title: messages['keysfobs_tab_hex'],
            show: true,
            sort: true,
            width: 300,
            export: true,
            functionString: 'return row?.hex',
            code: "keysfobs_tab_hex",
            render: (item) => {
                return (<span>{item.hex}</span>)
            }
        },
        {
            key: "company_name",
            field: "company { id name }",
            title: messages['keysfobs_tab_account'],
            show: true,
            sort: true,
            width: 300,
            export: true,
            functionString: 'return row?.company?.name',
            code: "keysfobs_tab_account",
            render: (item) => {
                return (
                    <NavLink to={`/app/accounts/overview/${item?.company?.id}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.company?.name}</span>
                    </NavLink>
                )
            }
        },
        {
            key: "driver_name",
            field: "driver.name",
            title: messages['keysfobs_tab_driver'],
            show: true,
            sort: true,
            width: 300,
            export: true,
            functionString: 'return row?.driver?.name',
            code: "keysfobs_tab_driver",
            render: (item) => {
                return <span>{item?.driver?.name}</span>
            }
        },
        {
            key: "keyFobModel_name",
            field: "keyFobModel { id name }",
            title: messages['keysfobs_tab_model'],
            show: true,
            sort: true,
            width: 300,
            export: true,
            functionString: 'return row?.keyFobModel?.name',
            code: "keysfobs_tab_model",
            render: (item) => {
                return (<span>{item.keyFobModel?.name}</span>)
            }
        }
    ])
    const [searchFields, setSearchFields] = useState(["hex", "company_name", "driver_name"]);

    // =========================================================================
    // CALLBACK HANDLERS
    // =========================================================================

    const handleChangeTotal = (total) => setTotal(total);

    const handleChangeConditions = (tags, conditions, total, newColumns, rows, sort, key, fromPreferences, restoreOnly) => {
        // restoreOnly: data already persisted in redux, just sync UI states — skip getData
        if (restoreOnly) return;

        let currentConditions = {}
        let currentTags = {}

        if (!conditions && tags) {
            currentConditions = tableRef?.current?.conditions;
            currentTags = tags;
        } else {
            currentConditions = conditions || [];
            currentTags = currentConditions?.filter((x) => x?.tags)[0]?.tags || [];
            if (currentTags && currentTags.length > 0) tableRef?.current?.setTags(currentTags);

            console.log("Current Conditions on Change:", currentConditions);
            let validateAccount = currentConditions && currentConditions?.find((x) => x?.fields[0] === "companyId");
            validateAccount && setAccount(validateAccount.account);

            let validateKeyFobModel = currentConditions && currentConditions?.find((x) => x?.fields[0] === "keyFobModel_id");
            validateKeyFobModel && setKeyFobModel(validateKeyFobModel.terms[0]);
        }

        currentConditions = currentConditions?.filter((item) => item?.fields[0] !== 'id' && item?.fields[0] !== 'hex');

        let tagsById = currentTags.filter((item) => item.id !== item.hex);
        if (tagsById?.length > 0) {
            let currentIds = tagsById.map((item) => (item.id));
            if (currentIds.length > 0) {
                currentConditions.push({ fields: ["id"], terms: currentIds, exact: true, tags: tagsById, conditionOperator: "OR" });
            }
        }
        let tagsByLabel = currentTags.filter((item) => item.id === item.hex);
        if (tagsByLabel.length > 0) {
            let currentLabels = tagsByLabel.map((item) => (item.hex))
            if (currentLabels.length > 0) {
                currentConditions.push({ fields: searchFields, terms: currentLabels, exact: false, tags: tagsByLabel, conditionOperator: "OR" })
            }
        }

        if (!conditions && tags) tableRef?.current?.getData({ newConditions: currentConditions });
        else if (!total) tableRef?.current?.getData({ newConditions: currentConditions, newRows: rows, newSort: sort });
    };

    const handleChangeColumns = (items) => setColumns(items);

    const handleFilters = () => setOpenPanel(!openPanel);

    const handleClickMenu = (event, item) => {
        if (event === messages['edit']) {
            if (HasPermission(user, "kfb", "u")) {
                dispatch(keyfobsCreateEditOpenModal(item?.id));
            } else {
                NotificationManager.warning(
                    messages['common_error_permission'],
                    messages['edit'],
                    5000,
                );
            }
        }
        if (event === messages['delete']) {
            if (HasPermission(user, "kfb", "d")) {
                dispatch(keyfobsDeleteOpenModal(item));
            } else {
                NotificationManager.warning(
                    messages['common_error_permission'],
                    messages['delete'],
                    5000,
                );
            }
        }
    };

    const menuOptions = () => [messages['edit'], messages['delete']];

    // Custom label for search options: "hex - driver (company)"
    const openSearchCustomOptions = (option) => {
        const hex = option?.hex || '';
        const driver = option?.driver?.name || '';
        const company = option?.company?.name || '';
        
        let label = hex;
        if (driver) label += ` - ${driver}`;
        if (company) label += ` (${company})`;
        
        return label;
    };

    const tableOptions = [
        {
            id: "edit-keyfobs",
            label: messages['edit'],
            show: true,
            single: true,
            disabled: !HasPermission(user, "kfb", "u"),
            action: (items) => {
                let currentKey = items[0]?.id
                currentKey && dispatch(keyfobsCreateEditOpenModal(currentKey));
            }
        },
        {
            id: "move-keyfobs",
            label: messages['keyfobs_main_move'],
            show: true,
            disabled: !HasPermission(user, "kfb", "u"),
            action: (items) => {
                dispatch(moveToAnotherAccountOpenModal(items));
            }
        },
        {
            id: "unassign-keyfobs",
            label: messages['keyfobs_main_unassign'],
            show: true,
            disabled: !HasPermission(user, "kfb", "u"),
            action: (items) => {
                dispatch(unassignDriversOpenModal(items));
            }
        },
        {
            id: "delete-keyfobs",
            label: messages['delete'],
            show: true,
            single: true,
            disabled: !HasPermission(user, "kfb", "d"),
            action: (items) => {
                let currentKey = items[0]
                dispatch(keyfobsDeleteOpenModal(currentKey))
            }
        }
    ];

    // =========================================================================
    // CONFIG OBJECTS
    // =========================================================================

    const graphqlConfig = {
        function: "searchKeyFobs",
        sortType: "KeyFobSortInput",
        conditionsType: "KeyFobSearchInput",
        customQuery: "id",
        dynamicQuery: true
    };

    const exportConfig = {
        fileName: "keyfobs"
    };

    const searchConfig = {
        conditions: ["hex", "company_name", "driver_name"],
        optionValue: "id",
        optionLabel: "hex",
        fields: searchFields,
        extraField: "driver { id name } company { id name }",
        openCustomOptions: openSearchCustomOptions
    };

    const uiConfig = {
        hideSplit: true,
        topHeight: 190,
        hideAllInPagination: true,
        filterSelected: (account || keyFobModel)
    };

    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Grid item xs={6}>
                        <Typography variant="h5" component="div">
                            {messages['keyfobs_main_title']} {/* ({total}) */}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ display: 'flex', justifyContent: 'right' }}>
                        <Button
                            className="btn-dark-blue"
                            disabled={!HasPermission(user, "kfb", "c")}
                            onClick={(e) => {
                                e.preventDefault();
                                dispatch(bulkAddDriverIdTagsOpenModal());
                            }}
                        >
                            {messages['keyfobs_main_add_driver_key']}
                        </Button>
                    </Grid>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <DataViewInfiniteScroll
                        ref={tableRef}
                        infiniteScroll={false}
                        selectionConfig={{ showCounter: false }}
                        clearOnUnmount
                        entity="keyfobs"
                        name="pm-keysfob-list"
                        tableButtons={["export", 'orderColumn']}
                        columns={columns}
                        onChangeTotal={handleChangeTotal}
                        asyncSelect
                        onChangeConditions={handleChangeConditions}
                        onChangeColumns={handleChangeColumns}
                        options={tableOptions}
                        menuOptions={menuOptions}
                        onClickMenu={handleClickMenu}
                        onFilters={handleFilters}
                        graphqlConfig={graphqlConfig}
                        exportConfig={exportConfig}
                        searchConfig={searchConfig}
                        uiConfig={uiConfig}
                        defaultsConfig={{
                            rowsPerPage: 25,
                            valuesPerPage: [10, 25, 50]
                        }}
                    />
                </Grid>
            </Paper>
            {openModalCreateEdit && <CreateEditKeyFob tableRef={tableRef} />}
            {openModalDelete && <DeleteKeyFob tableRef={tableRef} />}
            {openModalBulkAddDriverIdTags && <BulkAddDriverIDTags principalTableRef={tableRef} />}
            {
                !openPanelDetails && !openModalBulkAddDriverIdTags &&
                <AdvancedFilters
                    setOpenPanel={setOpenPanel}
                    openPanel={openPanel}
                    tableRef={tableRef}
                    account={account}
                    setAccount={setAccount}
                    keyFobModel={keyFobModel}
                    setKeyFobModel={setKeyFobModel}
                    setTotal={setTotal}
                />
            }
            {openModalMoveToAnotherAccount && <MoveToAnotherAccount tableRef={tableRef} />}
            {openModalUnassignDrivers && <UnassignDrivers tableRef={tableRef} />}
        </Container>
    )
}
export default KeyFobsMain;